var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 44,
    height: 37,
    viewBox: "0 0 5.17 4.37",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.86 1.31.01-.01c.07-.22.17-.41.35-.67.17-.25.48-.42.82-.52h.02C2.45 0 2.9-.02 3.21.02c.16.03.4.16.6.32l.01.02c.21.17.39.38.41.53.03.16-.08.31-.24.34-.16.03-.31-.08-.34-.25 0 0-.09-.08-.2-.17L3.44.8C3.31.7 3.18.62 3.12.61c-.23-.04-.59-.02-.9.07h-.01c-.23.07-.42.16-.5.28-.15.22-.23.37-.29.53-.01.05-.03.1-.04.16.18-.06.36-.13.5-.19.02-.02.08-.03.13-.04.05-.02.11-.03.15-.02.16.01.28.16.26.32a.29.29 0 0 1-.27.27h-.02c-.19.09-.39.16-.59.23-.17.06-.34.12-.46.17-.09.05-.21.04-.3-.02-.06-.05-.12-.16-.2-.32-.16-.31-.46-.88-.52-.96C-.04.96-.01.78.11.68a.3.3 0 0 1 .42.05c.06.08.19.33.33.58zm4.25 1.97c.1.13.07.31-.06.41-.13.1-.31.08-.41-.05-.06-.08-.2-.33-.33-.59l-.01.02c-.07.22-.18.41-.35.67-.17.25-.48.42-.83.52h-.01c-.39.11-.84.13-1.15.09-.17-.03-.4-.17-.6-.32l-.02-.02c-.2-.17-.38-.38-.41-.53-.02-.16.09-.31.25-.34.16-.03.31.08.34.24 0 .01.08.09.19.18l.02.01c.13.1.26.18.32.19.23.04.58.02.9-.07h.01c.23-.07.42-.16.5-.28.15-.22.23-.37.28-.53.02-.05.04-.1.05-.16-.18.06-.36.13-.5.19-.02.01-.08.03-.13.04-.05.02-.11.03-.15.02a.307.307 0 0 1-.27-.32c.02-.15.14-.26.28-.27h.02c.19-.09.39-.16.59-.23.17-.06.34-.12.46-.17.09-.05.21-.04.3.02.06.05.12.16.2.32.16.31.45.88.52.96zm-2.08-.9h-.01.01zm-.89-.39h.01-.01z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

export default SvgReset;